// Shared ES module used by the browser download and Django's fixed Node renderer.
const escapeHTML = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const escapeValues = value => {
  if (typeof value === 'string') return escapeHTML(value);
  if (Array.isArray(value)) return value.map(escapeValues);
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([k,v]) => [escapeHTML(k), escapeValues(v)]));
  return value;
};
export function buildHTMLReport(rawData, rawFindings, logoBase64, rawDetectorNames = {}) {
  const detectorNames = escapeValues(rawDetectorNames);
  const data = escapeValues(rawData);
  const vulndata = escapeValues(rawFindings);
  const severityOrder = {critical: 1, high: 2, medium: 3, low: 4};
    // Process vulnerabilities for table
    const sortedVulnerabilities = ["critical", "high", "medium", "low"]
    .flatMap(severity => {
      const issues = data?.classified_results?.[severity] || [];
      return issues.map(issue => ({
        ...issue,
        severity: severity
      }));
    })
    .sort((a, b) => {
        return (severityOrder[a.severity] || 5) - (severityOrder[b.severity] || 5);
    });


    const renderValue = (value) => {
      if (value === null || value === undefined) return 'N/A';
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
    };


    return `
  <!DOCTYPE html>
  <html>
  <head>
    <meta charset="UTF-8">
    <title>LLMINATE Security Report</title>
    <style>
      * { margin: 0; padding: 0; box-sizing: border-box; }
      .navbar {
        position: sticky;
        top: 0;
        width: 100%;
        z-index: 1000;
        background: #020617;
        border-bottom: 1px solid #1e293b;
      }

      .navbar-container {
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 40px;
        padding: 16px 0;
      }

      .nav-link {
        color: #cbd5e1;
        text-decoration: none;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.4px;
        padding: 6px 12px;
        border-radius: 6px;
        transition: all 0.2s ease;
      }

      .nav-link:hover {
        background: #1e293b;
        color: #fff;
      }

      html {
        scroll-behavior: smooth;
      }
      section, div[id] {
        scroll-margin-top:  110px;
      }
      body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        background: #000;
        color: #fff;
        padding: 40px;
        padding-top: 0px;
        line-height: 1.6;
      }
      .container { max-width: 1200px; margin: 0 auto; }
      .header {
        border-bottom: 2px solid #1e293b;
        padding-bottom: 30px;
        margin-bottom: 40px;
      }
      .logo {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 15px;
        margin-top: 30px;
      }
      .line {
        display: block;
        margin-top: 5px;
        margin-left: 0px;
        height: 12px;
      }
      h1 {
        font-size: 36px;
        font-weight: 800;
        color: #fff;
        margin-bottom: 8px;
      }
      .heading {
        font-size: 30px;
        line-height: 1;
        margin-bottom: 5px;
        /* margin-top: 30px; */
      }
      .subtitle {
        color: #94a3b8;
        font-size: 16px;
        margin-top: 25px;
        margin-left: 0px;
      }
      .meta {
        display: flex;
        gap: 30px;
        margin-top: 20px;
        padding: 20px;
        background: #0f172a;
        border-radius: 8px;
        border: 1px solid #1e293b;
        flex-wrap: wrap;
      }
      .meta-item {
        display: flex;
        flex-direction: column;
      }
      .meta-label {
        color: #64748b;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 4px;
      }
      .meta-value {
        color: #fff;
        font-weight: 600;
      }
      .summary {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 20px;
        margin-bottom: 40px;
      }
      .summary-card {
        background: #0f172a;
        border: 1px solid #1e293b;
        border-radius: 12px;
        padding: 24px;
      }
      .summary-card-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 12px;
        color: #94a3b8;
        font-size: 13px;
      }
      .summary-card-value {
        font-size: 32px;
        font-weight: 700;
      }
      .critical { color: #ef4444; }
      .high { color: #f97316; }
      .medium { color: #eab308; }
      .low { color: #22c55e; }
      .vulnerabilities {
        background: #0f172a;
        border: 1px solid #1e293b;
        border-radius: 12px;
        padding: 30px;
      }
      .vulnerabilities-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #1e293b;
      }
      .summary-h2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        margin-left: 10px;
        /* padding-bottom: 20px; */
        /* border-bottom: 1px solid #1e293b; */
      }
      h2 {
        font-size: 24px;
        font-weight: 700;
      }
      .vuln-item {
        background: rgba(15, 23, 42, 0.5);
        border-radius: 8px;
        padding: 24px;
        margin-bottom: 16px;
        border-left: 4px solid;
      }
      .vuln-item.critical { border-left-color: #ef4444; }
      .vuln-item.high { border-left-color: #f97316; }
      .vuln-item.medium { border-left-color: #eab308; }
      .vuln-item.low { border-left-color: #22c55e; }
      .vuln-header {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
        margin-bottom: 12px;
      }
      .vuln-title {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
      }
      .badge {
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      .badge-critical {
        background: rgba(239, 68, 68, 0.2);
        color: #ef4444;
      }
      .badge-high {
        background: rgba(249, 115, 22, 0.2);
        color: #f97316;
      }
      .badge-medium {
        background: rgba(234, 179, 8, 0.2);
        color: #eab308;
      }
      .badge-low {
        background: rgba(34, 197, 94, 0.2);
        color: #22c55e;
      }
      .badge-category {
        background: #334155;
        color: #cbd5e1;
      }
      .vuln-description {
        color: #cbd5e1;
        font-size: 14px;
        margin-bottom: 12px;
        line-height: 1.6;
      }
      .vuln-location {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #64748b;
        font-size: 12px;
        font-family: 'Courier New', monospace;
      }
      .evidence {
        margin-top: 16px;
        padding-top: 16px;
        border-top: 1px solid #1e293b;
      }
      .evidence-code {
        background: #020617;
        border: 1px solid #1e293b;
        border-radius: 6px;
        padding: 12px;
        font-family: 'Courier New', monospace;
        font-size: 12px;
        color: #94a3b8;
        word-wrap: break-word;
      }
      .footer {
        margin-top: 60px;
        padding-top: 30px;
        border-top: 1px solid #1e293b;
        text-align: center;
        color: #64748b;
        font-size: 13px;
      }
      .framework-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        margin-top: 20px;
      }
      .framework-card {
        background: #0f172a;
        border: 1px solid #1e293b;
        border-radius: 12px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .framework-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .framework-name {
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        font-family: monospace;
      }
      .sev-badge {
        padding: 3px 10px;
        border-radius: 9999px;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }
      .compliance-bar-track {
        height: 3px;
        border-radius: 9999px;
        background: #1e293b;
        position: relative;
        overflow: hidden;
      }
      .compliance-bar-fill {
        position: absolute;
        left: 0; top: 0; bottom: 0;
        border-radius: 9999px;
      }
      .plugin-list {
        display: flex;
        flex-direction: column;
        gap: 6px;
        max-height: 160px;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: #3c3c3c transparent;
      }
      .plugin-list::-webkit-scrollbar {
        width: 4px;
      }
      .plugin-list::-webkit-scrollbar-track {
        background: transparent;
      }
      .plugin-list::-webkit-scrollbar-thumb {
        background: #3c3c3c;
        border-radius: 9999px;
      }
      .plugin-list::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
      .plugin-row {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 10px;
        border-radius: 8px;
        background: #1e293b;
      }
      .plugin-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        flex-shrink: 0;
      }
      .plugin-name {
        font-size: 12px;
        font-family: monospace;
        color: #e2e8f0;
      }
      .framework-footer {
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        font-family: monospace;
        color: #64748b;
        padding-top: 4px;
      }
      @media print {
        body { background: #fff; color: #000; }
        .summary-card, .vulnerabilities, .vuln-item {
          background: #f8fafc;
          border-color: #e2e8f0;
        }
      }
    </style>
  </head>
  <script>
    const links = document.querySelectorAll(".nav-link")
    const sections = document.querySelectorAll("section, div[id]")

    window.addEventListener("scroll", () => {
      let current = ""
      sections.forEach(section => {
        const sectionTop = section.offsetTop - 100
        if (scrollY >= sectionTop) {
          current = section.getAttribute("id")
        }
      })
      links.forEach(link => {
        link.style.background = ""
        if (link.getAttribute("href") === "#" + current) {
          link.style.background = "#1e293b"
        }
      })
    })
  </script>
  <div class="navbar">
      <div class="navbar-container">
        <a class="nav-link" href="#summary">Summary</a>
        <a class="nav-link" href="#risk-categories">Risk Categories</a>
        <a class="nav-link" href="#security-compliance">Security Compliance</a>
        <a class="nav-link" href="#vulnerabilities">Vulnerability Details</a>
        <a class="nav-link" href="#prompts">Prompts & Responses</a>
      </div>
  </div>
  <body>
    <div class="container">
      <div class="header">
        <div class="logo">
          <img src="${logoBase64}" alt="LLMINATE" style="width: 60px; height: 60px;">
          <div>
            <h1 class="heading">LLMINATE Comprehensive Red Team Report</h1>
            <img class="line" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAAAYCAYAAABk8drWAAAFWklEQVR4AezZ8XUUNxAGcEEDkA5IBSEVBCoIHQAVABUYKghUAFQAVABUgFMB7iBOBc7309u5jPfuns/vOf4j+J6+lXY0Mxp9I2l37dvjmn5nZ2cPgrfBy0vgXXTZvU59GTu6H0wtdh8C94fCWE8uaVO+P18boSYXvL9169bLQxH9d4FyeqhN6cXoz0D5VLJD6hi8DmY5RL/rxOjrdROaMf/f5YbQK87vDaE3hF4xA1fs7naeZlUeXLHvH9LdzZa/4rTfEPpfEpq9fzfwUgv3+liRe8GG+12unT52+uAu2Y+KvkKfhYS/grcLvoeoo7SrPEnjM0S+Js3LsL63edE9jc6+ci+2E10hMgmZ8rTV3b/ErvvJuovZXmzZ6582s2N1id7sSz11l7qPubFIH91nqX3lfU5d8AX2eKO4NDqhjyJDxvFSpxo+qZ5rBPXVYmDkRjRGBhB8OX45hfsvkvU93ZLFruy/kS3Qnn25V9hI9rSLYNYZV/mWS9eV1NkfvbJJc6sYo/SqrvltlOObzCKzYMzZg7uAL5/GYsDJtOuEvo/k56ywX1PDSWplkhX5l9xAqiFYNXCsPokOH9oX4Ti6JwlYIL65ixQJfZg+SeVD8Op9cPwgXGLolp99+vSO0rlLr+aW7qHfvGEsP7HRqdgW8RADsodfJ/RdJsJopEbmKwrB/WXiaY6S2SomQFbkXrQ6i3g2XxefVpSAyIzdyST73WXBi8Q1S+4fBlVMXrv7d7+FjEl3X5xFlCSvSTf2TxlcfBbbm5VzNlPUCb0zJf9ekFp30yAOZQjIjxKgzAjykNX5G6MFH1P/EewlM775rf6ojhp3rH4SQdT979OVQLqw1ilC64ijA8i05bULjgKLq2A+s68TWituduSyWR0hspPLSboHfaSM/PZlPV3DNuvk8GUrSYZ+hMh8TYgM+FeDhPX+stV3vIP8raMnOnaSONiI4ZPGAkfQaXT0i20Rjy+Z+5rMERn9/lezTWyd0Odx6Enm1edojFGZOpfJOHMPIz8r12S3JpC+Xjo5gi5C9pHJtk9MUjwgwSqrPvYS3P0jC/iYyLyM2ZPuyOgrugipOU+7XKzEVMP4j+OnnvC9nmf4VMqlE4okExVwDS7gp9Fbl05g6a51+n0R0GXa/j5ak3E/kcAlqpOEkKN0QsmRZmWrN7spOuaR6lwRI5+Eb7Io2Ow6TjrJdPsqxo2x1/ibYgGhAoAXEco2EoGsAk7XznLh6txBjsmUM1n3F3Irb4N09m1WsYinw2QfxT+y1g8kk4+bWSShEsqX1cZGkqZCLnYlWSc54mHXzrjcBMZfL4A7YoD037udbCEN6lzwNIMpi9KucrQIBbE091YyWp1I6Cveqtn6a3wpL/XHFqOYCs8jN75JLqqzsjA2WzWSTtzT2NjWnRTjk/MV9XPldfTrrJzjpnf9hPfQKp0nVmh0Di/JhOwL0kpD0EXGffV8SIAIgLLzFYLYulf3Lbx5gurYAfGU2ENkrsIStNprYfnqSe7kmlMzGbVwuqzHZhGeG+9ShIZMRNYgzr9zzvqord0D+LrIHS1LcyDTqhl+GcNkydxC2WjvQj/39iUYUX3MX5qj+t8TUX82uLflPYDmtk9sHkDi0wdbsV2K0HhwFiFVgH1bpWu7JACDFzlWDzuvHVYolJFXmmofuuKchc488ZRt91kytS05x3YTsEs1i4fwbGT32PZrUs3BIgKx1XzYbGzdwKUIzYCvAsUnag+Qr10QuEnC+uyxYsjBu6TAywcZrG2qv2pk0gNnbW1fO4cMxLwhKUlmQ08f9BUq2Uhzzuvjp8bSNmfHhricu1s74h8AAAD//7vTuf8AAAAGSURBVAMAXr89/I1RXFsAAAAASUVORK5CYII=" alt="by KPMG" style="height: 16px; margin: 0px 0;">
          </div>
        </div>
        <p class="subtitle">LLM Security Assessment on: <strong>${data?.provider || 'N/A'}</strong></p>

        <div class="meta">
          <div class="meta-item">
            <span class="meta-label">Report Generated</span>
            <span class="meta-value">${data?.time || 'N/A'}</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">Evaluation ID</span>
            <span class="meta-value">${data?.evalId || 'N/A'}</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">Target</span>
            <span class="meta-value">${data?.target || 'N/A'}</span>
          </div>
        </div>
      </div>

      <div class="summary-h2">
        <h2>Summary</h2>
      </div>

      <div class="summary" id="summary">
        
        <div class="summary-card">
          <div class="summary-card-header">
            <span>Total Issues</span>
          </div>
          <div class="summary-card-value">${sortedVulnerabilities.length}</div>
        </div>
        <div class="summary-card">
          <div class="summary-card-header">
            <span>Critical</span>
          </div>
          <div class="summary-card-value critical">${data?.severity_counts?.critical ?? 0}</div>
        </div>
        <div class="summary-card">
          <div class="summary-card-header">
            <span>High</span>
          </div>
          <div class="summary-card-value high">${data?.severity_counts?.high ?? 0}</div>
        </div>
        <div class="summary-card">
          <div class="summary-card-header">
            <span>Medium</span>
          </div>
          <div class="summary-card-value medium">${data?.severity_counts?.medium ?? 0}</div>
        </div>
        <div class="summary-card">
          <div class="summary-card-header">
            <span>Low</span>
          </div>
          <div class="summary-card-value low">${data?.severity_counts?.low ?? 0}</div>
        </div>
      </div>

      <div class="vulnerabilities" id="risk-categories" style="margin-top: 40px;">
        <div class="vulnerabilities-header">
          <h2>Risk Categories</h2>
        </div>
        
        <div style="margin-top: 20px;">
          ${data?.issues_count ? Object.entries(data.issues_count).map(([category, subCategories]) => {
            const all = Object.values(subCategories);
            const passCount = all.reduce((sum, item) => sum + (item.Pass || 0), 0);
            const failCount = all.reduce((sum, item) => sum + (item.Fail || 0), 0);
            const errorCount = all.reduce((sum, item) => sum + (item.Error || 0), 0);
            const totalCount = all.reduce((sum, item) => sum + (item.Total || 0), 0);
            
            const allDetectorsPassed = Object.values(subCategories).every(subVal => (subVal.Fail || 0) === 0);
            
            return '<div style="background-color: #0f172a; border: 1px solid #1e293b; border-radius: 8px; margin-bottom: 20px; overflow: hidden;">'
              + '<div style="display: flex; flex-direction: row;">'

              + '<div style="width: 120px; background-color: #1e293b; display: flex; align-items: center; justify-content: center; border-top-left-radius: 8px; border-bottom-left-radius: 8px">'
              + '<div style="transform: rotate(-90deg); width: 180px; text-align: center;">'
              + '<span style="color: #fff; font-weight: 600; font-size: 16px;">'
              + category +
              '</span>'
              + '</div>'
              + '</div>'

              + '<div style="flex: 1; display: flex; border-left: 1px solid #1e293b;">'

              + '<div style="width: 25%; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 20px; border-right: 1px solid #1e293b;">'
              + '<span style="font-size: 28px; font-weight: 700; color: #fff;">'
              + failCount + '/' + totalCount +
              '</span>'
              + '<span style="color: #94a3b8; font-size: 12px; margin-top: 8px;">Test Cases Failed</span>'
              + '</div>'

              + '<div style="width: 40%; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 20px; border-right: 1px solid #1e293b;">'
              + '<svg viewBox="0 0 120 120" style="width: 100px; height: 100px;">'
              + (() => {
              const colors = ['#22c55e', '#ef4444', '#9ca3af'];
              const values = [passCount, failCount, errorCount];
              const total = values.reduce((a, b) => a + b, 0);
              if (total === 0) return '';
              let currentAngle = -Math.PI / 2;
              const paths = values.map((val, idx) => {
                if (val === 0) return '';
                const percentage = val / total;
                const angle = percentage * 2 * Math.PI;
                const radius = 40;
                const centerX = 60;
                const centerY = 60;
                const innerRadius = 25;
                
                const startX = centerX + radius * Math.cos(currentAngle);
                const startY = centerY + radius * Math.sin(currentAngle);
                currentAngle += angle;
                const endX = centerX + radius * Math.cos(currentAngle);
                const endY = centerY + radius * Math.sin(currentAngle);
                
                const startInnerX = centerX + innerRadius * Math.cos(currentAngle - angle);
                const startInnerY = centerY + innerRadius * Math.sin(currentAngle - angle);
                const endInnerX = centerX + innerRadius * Math.cos(currentAngle);
                const endInnerY = centerY + innerRadius * Math.sin(currentAngle);
                
                const largeArc = angle > Math.PI ? 1 : 0;
                return '<path d="M ' + startX + ' ' + startY + ' A ' + radius + ' ' + radius + ' 0 ' + largeArc + ' 1 ' + endX + ' ' + endY + ' L ' + endInnerX + ' ' + endInnerY + ' A ' + innerRadius + ' ' + innerRadius + ' 0 ' + largeArc + ' 0 ' + startInnerX + ' ' + startInnerY + ' Z" fill="' + colors[idx] + '" stroke="none"/>';
              }).join('');
              return paths;
            })() + '</svg><div style="margin-top: 12px; font-size: 12px;"><div style="display: flex; align-items: center; gap: 6px; margin: 4px 0;"><span style="width: 8px; height: 8px; background-color: #22c55e; border-radius: 50%;"></span><span style="color: #cbd5e1;">Pass - ' + passCount + '</span></div><div style="display: flex; align-items: center; gap: 6px; margin: 4px 0;"><span style="width: 8px; height: 8px; background-color: #ef4444; border-radius: 50%;"></span><span style="color: #cbd5e1;">Fail - ' + failCount + '</span></div><div style="display: flex; align-items: center; gap: 6px; margin: 4px 0;"><span style="width: 8px; height: 8px; background-color: #9ca3af; border-radius: 50%;"></span><span style="color: #cbd5e1;">Error - ' + errorCount + '</span></div></div></div><div style="width: 35%; padding: 20px; border-left: 1px solid #1e293b;"><p style="font-weight: 600; margin-bottom: 12px; color: #fff;">Detectors</p>' + (allDetectorsPassed ? '<span style="color: #22c55e; font-size: 12px;">No Failed Cases</span>' : '<div style="font-size: 12px;">' + Object.entries(subCategories).map(([subName, subVal]) => {
              if ((subVal.Fail || 0) > 0) {
                return '<div style="display: flex; justify-content: space-between; align-items: center; margin: 6px 0;"><span style="color: #cbd5e1;">' + subName + '</span><span style="background-color: rgba(239, 68, 68, 0.2); color: #ef4444; padding: 4px 8px; border-radius: 12px; border: 1px solid #ef4444; font-size: 11px;">' + subVal.Fail + '</span></div>';
              }
              return '';
            }).join('') + '</div>') + '</div></div></div>';
          }).join('') : '<div style="text-align: center; padding: 40px; color: #94a3b8;">No Risk Categories data available</div>'}
        </div>
      </div>

      ${data?.framework_compliance ? (() => {
        const fc = data.framework_compliance;
        const complianceRate = Math.max(0, 100 - (fc.attackSuccessRate || 0));
        const sevStyles = {
          Critical:    { bg: 'rgba(188,43,48,0.12)',  color: '#BC2B30', border: 'rgba(188,43,48,0.25)' },
          High:        { bg: 'rgba(239,68,68,0.12)',  color: '#ef4444', border: 'rgba(239,68,68,0.25)' },
          Medium:      { bg: 'rgba(245,158,11,0.12)', color: '#f59e0b', border: 'rgba(245,158,11,0.25)' },
          Low:         { bg: 'rgba(16,185,129,0.12)', color: '#10b981', border: 'rgba(16,185,129,0.25)' },
          Compliant:   { bg: 'rgba(16,185,129,0.12)', color: '#10b981', border: 'rgba(16,185,129,0.25)' },
          'Not Tested':{ bg: 'rgba(100,116,139,0.12)',color: '#64748b', border: 'rgba(100,116,139,0.25)' },
        };

        const frameworkCards = (fc.frameworks || []).map(fw => {
          const hasData = fw.totalPlugins > 0;
          const badgeKey = !hasData ? 'Not Tested' : fw.isCompliant ? 'Compliant' : fw.severity;
          const sev = sevStyles[badgeKey] || sevStyles.Low;
          const pct = hasData ? Math.round(fw.compliantPlugins / fw.totalPlugins * 100) : 0;

          const nonCompliantHtml = (fw.nonCompliantPlugins || []).map(p => {
            const pluginId = p.id ?? p;
            const pluginSev = p.severity ?? fw.severity;
            const ps = sevStyles[pluginSev] || sevStyles.Low;
            const name = detectorNames?.[pluginId] || pluginId;
            return '<div class="plugin-row">'
              + '<span class="plugin-dot" style="background:' + ps.color + '"></span>'
              + '<span class="plugin-name">' + name + '</span>'
              + '</div>';
          }).join('');

          const bodyHtml = !hasData
            ? '<span style="font-size:13px;color:#64748b;font-family:monospace;">No test data available</span>'
            : fw.isCompliant
              ? '<div style="display:flex;align-items:center;gap:8px;">'
                + '<span style="width:18px;height:18px;border-radius:50%;background:' + sev.bg + ';border:1px solid ' + sev.border + ';display:flex;align-items:center;justify-content:center;">'
                + '<svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5l2.5 2.5L8 3" stroke="#10b981" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                + '</span>'
                + '<span style="font-size:13px;font-family:monospace;color:' + sev.color + '">All detectors passed</span>'
                + '</div>'
              : '<p style="font-size:10px;font-family:monospace;color:#64748b;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:6px;">Non-Compliant Detectors</p>'
                + '<div class="plugin-list">' + nonCompliantHtml + '</div>';

          return '<div class="framework-card">'
            + '<div class="framework-card-header">'
            + '<span class="framework-name">' + fw.name + '</span>'
            + '<span class="sev-badge" style="background:' + sev.bg + ';color:' + sev.color + ';border:1px solid ' + sev.border + '">' + badgeKey + '</span>'
            + '</div>'
            + '<div class="compliance-bar-track">'
            + '<div class="compliance-bar-fill" style="width:' + pct + '%;background:' + sev.color + '"></div>'
            + '</div>'
            + bodyHtml
            + '<div class="framework-footer"><span>' + fw.compliantPlugins + '/' + fw.totalPlugins + ' passed</span><span>' + pct + '%</span></div>'
            + '</div>';
        }).join('');

        return '<div class="vulnerabilities" id="security-compliance" style="margin-top:40px;">'
          + '<div class="vulnerabilities-header"><h2>Security Compliance</h2></div>'
          + '<div style="background:#1e293b;border:1px solid #334155;border-radius:12px;padding:24px;margin-bottom:24px;">'
          + '<p style="color:#94a3b8;font-size:13px;margin-bottom:8px;">Compliance Rate</p>'
          + '<p style="font-size:28px;font-weight:700;color:#fff;margin-bottom:16px;">' + complianceRate.toFixed(1) + '%</p>'
          + '<div style="height:8px;width:100%;border-radius:9999px;background:rgba(0,0,0,0.3);position:relative;overflow:hidden;">'
          + '<div style="position:absolute;inset:0;background:linear-gradient(to right,#ef4444 0%,#f59e0b 50%,#22c55e 100%);"></div>'
          + '<div style="position:absolute;top:0;right:0;bottom:0;left:' + complianceRate.toFixed(1) + '%;background:#1e293b;"></div>'
          + '</div>'
          + '<p style="color:#64748b;font-size:12px;margin-top:8px;">'
          + (fc.failedTests || 0) + '/' + (fc.totalTests || 0) + ' tests failed across ' + (fc.total || 0) + ' plugins'
          + '</p>'
          + '</div>'
          + '<div class="framework-grid">' + frameworkCards + '</div>'
          + '</div>';
      })() : ''}

      <div class="vulnerabilities" id="vulnerabilities" style="margin-top: 40px;">
        <div class="vulnerabilities-header">
          <h2>Vulnerability Details</h2>
        </div>
        
        <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
          <thead>
            <tr style="background-color: #0f172a; border-bottom: 2px solid #1e293b;">
              <th style="padding: 12px; text-align: left; color: #cbd5e1; font-weight: 600; border-right: 1px solid #1e293b;">Type</th>
              <th style="padding: 12px; text-align: left; color: #cbd5e1; font-weight: 600; border-right: 1px solid #1e293b;">Description</th>
              <th style="padding: 12px; text-align: left; color: #cbd5e1; font-weight: 600;">Severity</th>
            </tr>
          </thead>
          <tbody>
            ${sortedVulnerabilities.length > 0 ? sortedVulnerabilities.map(issue => `
              <tr style="border-bottom: 1px solid #1e293b;">
                <td style="padding: 12px; color: #fff; border-right: 1px solid #1e293b;">${issue.type}</td>
                <td style="padding: 12px; color: #cbd5e1; border-right: 1px solid #1e293b;">${issue.description}</td>
                <td style="padding: 12px; text-align: center;">
                  <span style="background-color: rgba(${issue.severity === 'critical' ? '239, 68, 68' : issue.severity === 'high' ? '249, 115, 22' : issue.severity === 'medium' ? '234, 179, 8' : '34, 197, 94'}, 0.2); color: ${issue.severity === 'critical' ? '#ef4444' : issue.severity === 'high' ? '#f97316' : issue.severity === 'medium' ? '#eab308' : '#22c55e'}; padding: 6px 12px; border-radius: 20px; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">
                    ${issue.severity.charAt(0).toUpperCase() + issue.severity.slice(1)}
                  </span>
                </td>
              </tr>
            `).join('') : '<tr><td colspan="3" style="text-align: center; padding: 20px; color: #94a3b8;">No vulnerability data available</td></tr>'}
          </tbody>
        </table>
      </div>

      <div class="vulnerabilities" id="prompts" style="margin-top: 40px;">
        <div class="vulnerabilities-header">
          <h2>Prompts & Responses</h2>
        </div>
        
        ${vulndata && vulndata.length > 0 ? [...vulndata].sort((a, b) => {
          const severityOrder = {'critical': 1, 'high': 2, 'medium': 3, 'low': 4};
          const aScore = a.score ? String(a.score).toLowerCase() : '';
          const bScore = b.score ? String(b.score).toLowerCase() : '';
          return (severityOrder[aScore] || 5) - (severityOrder[bScore] || 5);
        }).map(row => `
          <div class="vuln-item ${row.score ? row.score.toLowerCase() : 'low'}" style="margin-bottom: 20px;">
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; margin-bottom: 12px;">
              <div>
                <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Prompt ID</span>
                <div style="color: #fff; margin-top: 4px;">${renderValue(row.testIdx)}</div>
              </div>
              <div>
                <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Category</span>
                <div style="color: #fff; margin-top: 4px;">${renderValue(row.category)}</div>
              </div>
              <div>
                <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Detector</span>
                <div style="color: #fff; margin-top: 4px;">${renderValue(row.type)}</div>
              </div>
            </div>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px;">
              <div>
                <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Method</span>
                <div style="color: #fff; margin-top: 4px;">${renderValue(row["Strategy Used"])}</div>
              </div>
              <div>
                <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Severity</span>
                <div style="margin-top: 4px;">
                  <span style="background-color: rgba(${row.score === 'critical' ? '239, 68, 68' : row.score === 'high' ? '249, 115, 22' : row.score === 'medium' ? '234, 179, 8' : '34, 197, 94'}, 0.2); color: ${row.score === 'critical' ? '#ef4444' : row.score === 'high' ? '#f97316' : row.score === 'medium' ? '#eab308' : '#22c55e'}; padding: 4px 8px; border-radius: 20px; font-size: 11px; font-weight: 600; text-transform: uppercase;">
                    ${row.score ? row.score.charAt(0).toUpperCase() + row.score.slice(1) : 'N/A'}
                  </span>
                </div>
              </div>
            </div>
            <div style="margin-top: 12px; padding-top: 12px; border-top: 1px solid #1e293b;">
              <div style="margin-bottom: 12px;">
                <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Prompt</span>
                <div style="color: #cbd5e1; margin-top: 6px; padding: 8px; background-color: rgba(15, 23, 42, 0.5); border-radius: 6px; font-family: 'Courier New', monospace; font-size: 12px; word-wrap: break-word;">${renderValue(row.prompt)}</div>
              </div>
              <div style="margin-bottom: 12px;">
                <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Response</span>
                <div style="color: #cbd5e1; margin-top: 6px; padding: 8px; background-color: rgba(15, 23, 42, 0.5); border-radius: 6px; font-family: 'Courier New', monospace; font-size: 12px; word-wrap: break-word;">${renderValue(row.response)}</div>
              </div>
              <div>
                <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Evaluation</span>
                <div style="color: #cbd5e1; margin-top: 6px; padding: 8px; background-color: rgba(15, 23, 42, 0.5); border-radius: 6px; font-family: 'Courier New', monospace; font-size: 12px; word-wrap: break-word;">${renderValue(row.error)}</div>
              </div>
            </div>
          </div>
        `).join('') : '<div style="text-align: center; color: #94a3b8; padding: 2rem;">No prompt data available</div>'}
      </div>

      <div class="footer">
        <p>This report was generated by LLMINATE Security Scanner</p>
        <p>© 2025 - Confidential Security Assessment</p>
      </div>
    </div>
  </body>
  </html>
    `;


}
